// extracted by mini-css-extract-plugin
export var smallSpinner = "_rt-0";